export const MSG = {
  CONFIG_SETTING: "설정 저장중입니다.",
  SAVE: "저장 중입니다...",
  TEAM_SAVE: "팀 설정을 저장 중입니다...",
  ACTIVE_SETTING_SAVE: "근무자 활성 설정을 저장 중입니다...",
};
